export default "__VITE_ASSET__BH5SOfAL__"